import {Component, OnDestroy, OnInit} from '@angular/core';
import {SubscriptionLike} from 'rxjs';
import {Breadcrumb} from '../../../modelo/producto/breadcrumb';
import {ProductoService} from '../../../servicios/producto/producto.service';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.css']
})
export class BreadcrumbComponent implements OnInit, OnDestroy {
  private subs:SubscriptionLike[];
  public breadcrumb:Breadcrumb;
  constructor(private produSV:ProductoService,private routerAc:ActivatedRoute) {
    this.subs=[];
  }

  ngOnInit(): void {
    this.subs.push(
      this.routerAc.queryParams.subscribe(parm=> {
        const t = parm.T != undefined ? parm.T : "";
        const l = parm.L != undefined ? parm.L : "";
        const r = parm.R != undefined ? parm.R : "";
        const f = parm.F != undefined ? parm.F : "";
        this.subs.push(
          this.produSV.armarMigaDePan(t,l,r,f).subscribe(res=>{
            this.breadcrumb=res.data;
          })
        )
      }));

  }

  ngOnDestroy(): void {
    this.subs.forEach(s=>s.unsubscribe());
  }

}
